module.exports = __webpack_public_path__ + "media/images/item/rate_1_5-6fd7387a6e1c7b846d7d9e15e173f207.png";